import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=3fa4c9ef&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=3fa4c9ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4c9ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src141814727/src/web-authentication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa4c9ef')) {
      api.createRecord('3fa4c9ef', component.options)
    } else {
      api.reload('3fa4c9ef', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=3fa4c9ef&scoped=true&", function () {
      api.rerender('3fa4c9ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/layout/Layout.vue"
export default component.exports